import $ from 'jquery';

function makePrimaryButton(label: string) {
  return $<HTMLButtonElement>(`<button type="button" class="modal-btn-confirm btn btn-primary">${label}</button>`);
}

function makeSecondaryButton(label: string) {
  return $<HTMLButtonElement>(`<button type="button" class="modal-btn-cancel btn btn-default">${label}</button>`);
}

function wrapCallback(func: (() => void) | undefined, wrapper: () => void) {
  return () => {
    wrapper();
    func?.();
  };
}

export default {
  makePrimaryButton,
  makeSecondaryButton,
  wrapCallback,
};
